/* eslint-disable max-len */
/* eslint-disable react/jsx-no-target-blank */
import React, { Component } from 'react';
import { withTranslation } from 'react-i18next';
import PropTypes from 'prop-types';
import {
  Button,
  Checkbox,
  Container,
  Dimmer,
  Divider,
  Form,
  Grid,
  Icon,
  Item,
  Label,
  Loader,
  Header,
  Modal,
  Segment,
  Table,
} from 'semantic-ui-react';
import moment from 'moment-timezone';
import { clone } from 'lodash';
import { connect } from 'react-redux';
import { Link, withRouter } from 'react-router';
import { replace } from 'react-router-redux';
// actions
import { fetchM } from '../../../actions/fetchM';
import { flashErrorMessage, flashSuccessMessage, flashMessage } from '../../../actions/flash';
// components
import { NoteEditor } from '../../../components/BookingNote';
import BookingFeePaymentList from '../../../components/BookingFeePaymentList';
import CurrencySymbol from '../../../components/CurrencySymbol';
import LoadImage from '../../../components/LoadImage';
import LoanAmount from '../../../components/LoanAmount';
import PAYMENT_STATUSES from '../../../constants/paymentStatuses';
import SearchStaff from '../../../components/SearchStaff';
import Timestamp from '../../../components/Timestamp';
// utils
import { AWSUrl, decodeSearch, encodeSearch } from '../../../utils/url';
import { centsToFloat } from '../../../utils/numbers/centsFloat';
import { spaFullNumber } from '../../../utils/amount';
import valueToText from '../../../utils/valueToText';
// types
import { BookingNoteDefault } from '../../../types/index';
// modal
import AttachmentModal from '../../BookingPayment/AttachmentModal';
import { cancellationCategoryLabel } from '../../../components/OpportunityCancelModal';
import { namespaces, TRANSLATION_FILES } from '../../../constants/translation';

class PendingUnits extends Component {
  static contextTypes = {
    store: PropTypes.object,
  }
  static propTypes = {
    appConfig: PropTypes.shape({
      data: PropTypes.shape({
        settings: PropTypes.shape({
          notesExternalPlaceholder: PropTypes.string,
        }),
      }),
    }),
    location: PropTypes.shape({
      query: PropTypes.object,
      search: PropTypes.string,
    }),
    auth: PropTypes.shape({
      isBranchLeader: PropTypes.bool,
      isHeadquarters: PropTypes.bool,
      company: PropTypes.shape({
        countryCode: PropTypes.string,
      }),
    }),
    data: PropTypes.arrayOf(PropTypes.shape({
      code: PropTypes.string,
    })),
    loading: PropTypes.bool,
    token: PropTypes.string,
    fetchProjectUnitBookings: PropTypes.func,
    pendingCancelUnitsTab: PropTypes.bool,
    t: PropTypes.func,
  }
  static mapStateToProps = state => ({
    auth: state.auth,
    appConfig: state.appConfig,
  })
  static getPropsToState = (props) => {
    const data = props.data;
    const loading = props.loading;
    // const modal = props.modal;
    const modal = {
      isOpen: false,
      header: '',
      headerIcon: 'warning sign',
      message: '',
      actionButtonText: 'Yes',
      unitID: '',
      bookingID: '',
      notes: '',
      isCancelPending: true,
      updatedAt: '',
    };
    const paymentModal = {
      isOpen: false,
      bookingID: '',
      unitID: '',
    };
    return {
      data,
      loading,
      modal,
      oriData: clone(data),
      paymentModal,
      noResultsMessage: 'Loading...',
    };
  }
  constructor(props) {
    super(props);
    const state = PendingUnits.getPropsToState(props);
    this.state = {
      ...state,
      attachmentModalState: false,
      attachmentModalData: {},
      bookingPaymentData: '',
      bookingPaymentToken: '',
      customerData: [],
      isDuplicate: false,
    };
  }
  componentWillReceiveProps(nextProps) {
    const state = PendingUnits.getPropsToState(nextProps);
    if (JSON.stringify(this.state.oriData) === JSON.stringify(state.oriData)) {
      state.data = this.state.data;
    }
    this.setState({ ...state });
  }
  getSelectedStaffValue = () => {
    const { bookingPaymentData } = this.state;
    const selectedStaffValue = {
      key: bookingPaymentData.assignedMaUserID.toString() || 0,
      title: bookingPaymentData.assignedMaName || '',
      price: bookingPaymentData.assignedMaPreferredName || '',
    };
    return selectedStaffValue;
  }
  setComponentState(state = {}) {
    return new Promise((res) => {
      this.setState(state, res);
    });
  }
  setLoading(loading = false) {
    return new Promise((res) => {
      this.setState({ loading }, res);
    });
  }
  isChequeDuplicated = (data) => {
    const { bookingFeePayments } = data;
    return (Array.isArray(bookingFeePayments) && bookingFeePayments.length > 0 && bookingFeePayments.some(bfp => bfp.isChequeDuplicate && ['cancelled', 'deduction'].every(s => bfp.status !== s)));
  }
  async fetchPrimaryBookingCustomer() {
    const { t } = this.props;
    const { store } = this.context;
    let res;
    try {
      res = await store.dispatch(fetchM(`/customers/${this.state.bookingPaymentData.customerID}/`, {
        credentials: 'include',
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
        },
      }));
    } catch (e) {
      Bugsnag.notifyException(e);
      await store.dispatch(flashErrorMessage({ message: t('An error occurred, please refresh page', { ns: TRANSLATION_FILES.translation }) }));
      await this.setLoading(false);
      return;
    }
    const json = await res.json();
    if (json) {
      const newCustData = Object.assign({}, json || {});
      this.setState({ customerData: newCustData });
    }
    await this.setLoading(false);
  }
  async fetchBookingPayment(bookingID) {
    await this.setLoading(true);
    const { t } = this.props;
    const { store } = this.context;
    let res;
    try {
      res = await store.dispatch(fetchM(`/bookings/${bookingID}/`, {
        credentials: 'include',
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
        },
      }));
    } catch (err) {
      if (err.res && err.res.status >= 399 && err.res.status < 500) {
        const message = await err.res.text();
        store.dispatch(flashErrorMessage({ message }));
      }
      await this.setLoading(false);
      Bugsnag.notifyException(err);
      store.dispatch(flashErrorMessage({ message: t('There was an error with your request. Please try again.', { ns: TRANSLATION_FILES.translation }) }));
    }
    if (!res.ok) {
      const message = await res.text();
      await store.dispatch(flashErrorMessage({ message }));
    } else {
      const bookingPaymentToken = res.headers.get('X-Csrf-Token');
      const bookingPaymentData = await res.json();
      await this.setComponentState({
        bookingPaymentToken,
        bookingPaymentData,
      });
      if (this.isChequeDuplicated(bookingPaymentData)) {
        await this.setComponentState({
          isDuplicate: true,
        });
      }
      await this.fetchPrimaryBookingCustomer();
    }
    await this.setLoading(false);
  }
  async putBooking(bookingData, unitID, bookingID, type, silentLoad = false) {
    const { store } = this.context;
    const { t } = this.props;
    if (!silentLoad) {
      await this.setLoading(true);
    }
    let res = '';
    try {
      res = await store.dispatch(fetchM(`/manage/project_units/${unitID}/bookings/${bookingID}/`, {
        credentials: 'include',
        method: 'PUT',
        headers: {
          'Content-Type': 'application/json',
          'X-Csrf-Token': this.props.token,
        },
        body: JSON.stringify(bookingData),
      }));
    } catch (err) {
      if (err.res && err.res.status >= 400 && err.res.status < 500) {
        const message = await err.res.text();
        store.dispatch(flashErrorMessage({ message }));
        return;
      }
      Bugsnag.notifyException(err);
      store.dispatch(flashErrorMessage({ message: t('There was an error with your request. Please try again.', { ns: TRANSLATION_FILES.translation }) }));
      return;
    }
    const respondData = await res.json();
    const query = decodeSearch(this.props.location.search);
    const modal = Object.assign({}, this.state.modal);
    if (this.state.data) {
      const { data } = this.state;
      data.map((unit, idx) => {
        if (unit.id === modal.unitID) {
          // Hide all cancelled bookings by same units
          if (modal.type === 'approve') {
            unit.bookings.map((booking, idxb) => {
              const updatedBooking = booking;
              if (booking.id === modal.bookingID) {
                updatedBooking.approve = true;
              } else {
                updatedBooking.decline = true;
              }
              data[idx].bookings[idxb] = updatedBooking;
              return null;
            });
          }
          if (modal.type === 'decline') {
            unit.bookings.map((booking, idxb) => {
              if (booking.id === modal.bookingID) {
                const updatedBooking = booking;
                updatedBooking.decline = true;
                data[idx].bookings[idxb] = updatedBooking;
              }
              return null;
            });
          }
        }
        return null;
      });
      this.setState({ data }, () => {
        modal.unitID = '';
        modal.bookingID = '';
        this.setState({ modal });
      });
    }
    await this.setLoading(false);
    store.dispatch(flashMessage({
      header: type === 'approve' ? t('Booking Confirmed', { ns: TRANSLATION_FILES.translation }) : t('Resevation Cancelled', { ns: TRANSLATION_FILES.translation }),
      message: type === 'approve' ? t('Booking {{code}} successfully confirmed', { code: respondData.code, ns: TRANSLATION_FILES.translation }) : t('Resevation {{code}} has been declined', { code: respondData.code, ns: TRANSLATION_FILES.translation }),
      icon: type === 'approve' ? 'checkmark' : 'x',
      type: 'success',
      autoHideDuration: 5000,
    }));
    if (this.state.autoReload) {
      this.timeout = setTimeout(() => {
        query.page = 1;
        this.fetchProjectUnitBookings(query, true);
        store.dispatch(replace(`/bookings/manage/?${encodeSearch(query)}`));
      }, 4000);
    }
  }
  async updateBookingPayment(bookingPaymentData, xid = this.state.data.id) {
    await this.setLoading(true);
    const query = decodeSearch(this.props.location.search);
    const payData = bookingPaymentData;
    payData.paymentAmount = parseFloat(payData.paymentAmount);
    const { t } = this.props;
    const { store } = this.context;
    let res = '';
    try {
      res = await store.dispatch(fetchM(`/bookings/${xid}/`, {
        credentials: 'include',
        method: 'PUT',
        headers: {
          'Content-Type': 'application/json',
          'X-Csrf-Token': this.state.bookingPaymentToken,
        },
        body: JSON.stringify(bookingPaymentData),
      }));
    } catch (err) {
      await this.setLoading(false);
      if (err.res && err.res.status >= 400 && err.res.status < 500) {
        const message = await err.res.text();
        store.dispatch(flashErrorMessage({ message }));
        return;
      }
      Bugsnag.notifyException(err);
      store.dispatch(flashErrorMessage({ message: t('There was an error with your request. Please try again.', { ns: TRANSLATION_FILES.translation }) }));
      return;
    }
    const respData = await res.json();
    if (this.state.data) {
      const { data, paymentModal } = this.state;
      data.map((unit, idx) => {
        if (unit.id === paymentModal.unitID) {
          unit.bookings.map((booking, idxb) => {
            const updatedBooking = booking;
            if (booking.id === paymentModal.bookingID) {
              updatedBooking.paymentStatus.name = respData.paymentStatusID
              .split(' ').map(w => w[0].toUpperCase() + w.substr(1).toLowerCase()).join(' ');
              updatedBooking.paymentStatus.id = respData.paymentStatusID;
              updatedBooking.paymentStatusID = respData.paymentStatusID;
            }
            data[idx].bookings[idxb] = updatedBooking;
            return null;
          });
        }
        return null;
      });
      paymentModal.unitID = '';
      paymentModal.bookingID = '';
      paymentModal.isOpen = false;
      this.setState({
        data,
        paymentModal,
        bookingPaymentData: '',
      }, () => {
        if (this.state.autoReload) {
          this.setRefreshDataTimeout();
        }
      });
    }
    await this.setLoading(false);
    store.dispatch(flashSuccessMessage({ header: t('Update Success', { ns: TRANSLATION_FILES.translation }), message: t('Booking {{code}} successfully updated.', { code: respData.code, ns: TRANSLATION_FILES.translation }) }));
    this.props.fetchProjectUnitBookings(query);
  }
  hasStaffAccess() {
    if (this.props.auth.isBranchLeader) {
      return false;
    }
    return true;
  }
  handleCloseModal = () => {
    const modal = Object.assign({}, this.state.modal);
    modal.isOpen = false;
    modal.notes = '';
    modal.updatedAt = '';
    this.setState({ modal });
  }
  handleOpenModal = (
    unitID,
    bookingID,
    notes,
    actionButtonText,
    headerIcon,
    header,
    message,
    type,
    updatedAt,
  ) => {
    const modal = Object.assign({}, this.state.modal);
    modal.unitID = unitID;
    modal.bookingID = bookingID;
    modal.notes = notes;
    modal.isOpen = true;
    modal.header = header;
    modal.message = message;
    modal.headerIcon = headerIcon;
    modal.actionButtonText = actionButtonText;
    modal.isCancelPending = false;
    modal.updatedAt = updatedAt;
    if (type === 'approve') {
      modal.type = 'approve';
      this.setState({ modal });
    } else if (type === 'decline') {
      modal.isCancelPending = true;
      modal.type = 'decline';
      this.setState({ modal });
    }
  }
  handleConfirm = () => {
    const { pendingCancelUnitsTab, t } = this.props;
    const modal = Object.assign({}, this.state.modal);
    if (!modal.notes) {
      const { store } = this.context;
      store.dispatch(flashErrorMessage({ header: t('Please fix form errors', { ns: TRANSLATION_FILES.translation }), message: t('Notes required', { ns: TRANSLATION_FILES.translation }) }));
      return;
    }
    modal.isOpen = false;
    let statusID;
    let isCancelPending = false;
    let declinedPendingCancellationAt = null;
    if (modal.type === 'approve') {
      // statusID = 'booked';
      // eslint-disable-next-line no-unused-expressions
      pendingCancelUnitsTab ? statusID = 'cancelled_developer' : statusID = 'booked';
    }
    if (modal.type === 'decline') {
      if (pendingCancelUnitsTab) {
        declinedPendingCancellationAt = moment().toDate();
      } else {
        statusID = 'cancelled_developer';
        if (modal.isCancelPending) {
          isCancelPending = true;
        }
      }
    }
    const bookingData = {
      declinedPendingCancellationAt,
      statusID,
      isCancelPending,
      newBookingNoteEncoded: modal.notes,
      updatedAt: modal.updatedAt,
    };
    this.setState({ modal }, () => {
      this.putBooking(bookingData, modal.unitID, modal.bookingID, modal.type, false);
    });
  }
  handleOpenPaymentModal = (bookingID, unitID) => {
    const paymentModal = {
      isOpen: true,
      bookingID,
      unitID,
    };
    this.setState({ paymentModal }, () => {
      this.fetchBookingPayment(bookingID);
    });
    if (this.timeoutRefresh) {
      clearTimeout(this.timeoutRefresh);
    }
  }
  handleSavePaymentModal = () => {
    const { bookingPaymentData, paymentModal } = this.state;
    this.updateBookingPayment(bookingPaymentData, paymentModal.bookingID);
  }
  handleClosePaymentModal = () => {
    const bookingPaymentData = '';
    const paymentModal = {
      isOpen: false,
      bookingID: '',
      unitID: '',
    };
    this.setState({ paymentModal, bookingPaymentData, isDuplicate: false }, () => {
      if (this.state.autoReload) {
        this.setRefreshDataTimeout();
      }
    });
  }
  handlePaymentChange = (event, value) => {
    const { bookingPaymentData } = this.state;
    bookingPaymentData[value.name] = value.value;
    this.setState({ bookingPaymentData });
  }
  handlePaymentNotesChange = (bnEncoded) => {
    const { bookingPaymentData } = this.state;
    bookingPaymentData.newBookingNoteEncoded = bnEncoded;
    this.setState({ bookingPaymentData });
  }
  handleStaffClear = () => {
    const { bookingPaymentData } = this.state;
    bookingPaymentData.assignedMaName = '';
    bookingPaymentData.assignedMaPreferredName = '';
    bookingPaymentData.assignedMaUserID = 0;
    this.setState({ bookingPaymentData });
  }
  handleStaffSelect = (value) => {
    const { bookingPaymentData } = this.state;
    bookingPaymentData.assignedMaName = value.title;
    bookingPaymentData.assignedMaPreferredName = value.price;
    bookingPaymentData.assignedMaUserID = value.key;
    this.setState({ bookingPaymentData });
  }
  handleNotesChange = (value) => {
    const { modal } = this.state;
    modal.notes = value;
    this.setState({ modal });
  }
  handleCheckboxChange = (event, { checked }) => {
    const { modal } = this.state;
    modal.isCancelPending = checked;
    this.setState({ modal });
  }
  handleOpenAttachment = (data) => {
    const d = {};
    d.paymentPictures = data.paymentPictures;
    d.bookingID = data.id;
    this.setState({
      attachmentModalState: true,
      attachmentModalData: d,
    });
  }
  handleCloseAttachment = () => {
    this.setState({
      attachmentModalState: false,
    });
  }
  generateRowStyle = (array) => {
    const newArray = array;
    let i = 1;
    const hasMultiple = i !== array.length;
    array.forEach((booking, idx) => {
      if (!hasMultiple && i === array.length) newArray[idx].className = 'start end';
      if (hasMultiple && i === (array.length - (array.length - 1))) newArray[idx].className = 'start';
      if (hasMultiple && i === array.length) newArray[idx].className = 'end';
      i += 1;
    });
    return newArray;
  }

  render() {
    const { auth, pendingCancelUnitsTab, t } = this.props;
    const countryCode = auth && auth.company && auth.company.countryCode;
    const showCancellationReason = pendingCancelUnitsTab && countryCode === 'vn';
    const {
      bookingPaymentData,
      bookingPaymentToken,
      customerData,
      isDuplicate,
      modal,
      paymentModal,
      attachmentModalData,
      attachmentModalState,
    } = this.state;

    return (
      <Container>
        <AttachmentModal
          modalState={attachmentModalState}
          data={attachmentModalData}
          onClose={this.handleCloseAttachment}
        />
        <Modal closeOnDimmerClick={false} closeOnDocumentClick={false} open={paymentModal.isOpen} size="large">
          <Header content={bookingPaymentData !== '' ? `${bookingPaymentData.bookingCustomer.title && `${t(bookingPaymentData.bookingCustomer.title, { ns: TRANSLATION_FILES.constants })} `}${t('bookingTitle', { ns: TRANSLATION_FILES.translation, name: bookingPaymentData.bookingCustomer.preferredName })}` : t('Manage Booking', { ns: TRANSLATION_FILES.translation })} />
          <Modal.Content>
            { bookingPaymentData !== '' ?
              <Grid>
                <Dimmer active={this.props.loading} inverted>
                  <Loader inline="centered">{t('Loading', { ns: TRANSLATION_FILES.translation })}</Loader>
                </Dimmer>
                <Grid.Row style={{ padding: '0.5em 0em' }}>
                  <Grid.Column mobile={16} tablet={16} computer={16}>
                    <Divider horizontal>
                      {t('Management', { ns: TRANSLATION_FILES.screens })}
                    </Divider>
                    <Grid verticalAlign="middle">
                      <Grid.Column textAlign="left" width={6}>
                        <b>{t('Assigned staff', { ns: TRANSLATION_FILES.screens })}</b>
                      </Grid.Column>
                      <Grid.Column width={10}>
                        <SearchStaff
                          onClear={this.handleStaffClear}
                          onSelect={this.handleStaffSelect}
                          selectedValue={this.getSelectedStaffValue()}
                        />
                      </Grid.Column>
                    </Grid>
                    <Grid verticalAlign="top">
                      <Grid.Column textAlign="left" width={6}>
                        <b>{t('Notes', { ns: TRANSLATION_FILES.screens })}</b>
                      </Grid.Column>
                      <Grid.Column width={10}>
                        <NoteEditor
                          bookingNote={{ ...BookingNoteDefault }}
                          hideCustomOptions
                          onUpdate={this.handlePaymentNotesChange}
                          auth={this.props.auth}
                          settings={this.props.appConfig && this.props.appConfig.data && this.props.appConfig.data.settings}
                        />
                      </Grid.Column>
                    </Grid>
                  </Grid.Column>
                </Grid.Row>
                <Grid.Row style={{ padding: '0.5em 0em' }}>
                  <Grid.Column mobile={16} tablet={16} computer={16}>
                    <Divider horizontal>
                      {t('Payment', { ns: TRANSLATION_FILES.screens })}
                    </Divider>
                  </Grid.Column>
                </Grid.Row>
                <Grid.Row>
                  <Grid.Column mobile={16} tablet={8} computer={8}>
                    <Grid verticalAlign="middle">
                      <Grid.Column textAlign="left" width={8}>
                        <b>{t('Amount', { ns: TRANSLATION_FILES.screens })}</b>
                      </Grid.Column>
                      <Grid.Column textAlign="right" width={8}>
                        <Form.Input
                          fluid
                          name="paymentAmount"
                          onChange={this.handlePaymentChange}
                          type="tel"
                          placeholder={t('Amount', { ns: TRANSLATION_FILES.screens })}
                          value={bookingPaymentData.paymentAmount}
                        />
                      </Grid.Column>
                    </Grid>
                    <Divider style={{ margin: '0.5em 0' }} />
                    <Grid verticalAlign="middle">
                      <Grid.Column textAlign="left" width={8}>
                        <b>{t('Outstanding', { ns: TRANSLATION_FILES.screens })}</b>
                      </Grid.Column>
                      <Grid.Column textAlign="right" width={8}>
                        {
                          bookingPaymentData.paymentAmount ?
                            <LoanAmount
                              format="0,000,000.00"
                              amount={
                                bookingPaymentData.paymentAmount - centsToFloat(
                                  bookingPaymentData.paymentPaidCents,
                                )
                              }
                              prefix={<CurrencySymbol />}
                            />
                          : '-'
                        }
                      </Grid.Column>
                    </Grid>
                    <Divider style={{ margin: '0.5em 0' }} />
                    <Grid verticalAlign="middle">
                      <Grid.Column textAlign="left" width={8}>
                        <b>{t('Payments Made', { ns: TRANSLATION_FILES.screens })}</b>
                      </Grid.Column>
                      <Grid.Column textAlign="right" width={8}>
                        <LoanAmount
                          format="0,000,000.00"
                          amount={centsToFloat(bookingPaymentData.paymentPaidCents)}
                          prefix={<CurrencySymbol />}
                        />
                      </Grid.Column>
                    </Grid>
                    <Divider style={{ margin: '0.5em 0' }} className="large-hide small-hide tablet-hide" />
                  </Grid.Column>
                  <Grid.Column mobile={16} tablet={8} computer={8}>
                    <Grid verticalAlign="middle">
                      <Grid.Column textAlign="left" width={8}>
                        <b>{t('Status', { ns: TRANSLATION_FILES.screens })}</b>
                      </Grid.Column>
                      <Grid.Column textAlign="right" width={8}>
                        {valueToText(PAYMENT_STATUSES, bookingPaymentData.paymentStatusID)}
                      </Grid.Column>
                    </Grid>
                    <Divider style={{ margin: '0.5em 0' }} />
                    <Grid verticalAlign="middle">
                      <Grid.Column textAlign="left" width={8}>
                        <b>{t('Notes', { ns: TRANSLATION_FILES.screens })}</b>
                      </Grid.Column>
                      <Grid.Column textAlign="right" width={8}>
                        <Form.Input
                          fluid
                          name="paymentNotes"
                          onChange={this.handlePaymentChange}
                          placeholder={t('Notes', { ns: TRANSLATION_FILES.screens })}
                          value={bookingPaymentData.paymentNotes}
                        />
                      </Grid.Column>
                    </Grid>
                  </Grid.Column>
                </Grid.Row>
                <Grid.Row>
                  <Grid.Column mobile={16} tablet={16} computer={16}>
                    <BookingFeePaymentList
                      bookingID={bookingPaymentData.id}
                      data={bookingPaymentData.bookingFeePayments || []}
                      listOnly
                      isSubModal
                      token={bookingPaymentToken || ''}
                    />
                  </Grid.Column>
                </Grid.Row>
                {
                  isDuplicate ? (
                    <Grid.Row>
                      <Grid.Column mobile={16} tablet={16} computer={16}>
                        <Container style={{ border: '2px solid red', textAlign: 'center', padding: '5px' }}>
                          <Label style={{ backgroundColor: 'transparent', color: 'red' }}>
                            Warning: Cheque reference number duplication detected. <br />
                            Please verify manually before approving/declining this reservation
                          </Label>
                        </Container>
                      </Grid.Column>
                    </Grid.Row>
                  ) : null
                }
                <Grid.Row style={{ padding: '0.5em 0em' }}>
                  <Grid.Column mobile={16} tablet={16} computer={16}>
                    <Divider horizontal>
                      {t('Purchaser Info', { ns: TRANSLATION_FILES.translation })}
                    </Divider>
                  </Grid.Column>
                </Grid.Row>
                <Grid.Row>
                  <Grid.Column mobile={16} tablet={16} computer={16}>
                    <Grid centered>
                      <Grid.Row>
                        <Grid.Column mobile={2} tablet={2} computer={2} textAlign="left">
                          <b>{t('Name', { ns: TRANSLATION_FILES.translation })}:</b>
                        </Grid.Column>
                        <Grid.Column mobile={8} tablet={8} computer={8} textAlign="left">
                          {bookingPaymentData.bookingCustomer.name}
                        </Grid.Column>
                      </Grid.Row>
                      {
                        customerData && (customerData.icFrontDocumentID !== '' || customerData.icBackDocumentID !== '') ? (
                          <div style={{ width: '100%' }}>
                            <Grid centered>
                              <Grid.Row>
                                <Grid.Column mobile={10} tablet={10} computer={10} textAlign="left">
                                  <b>{t('IC Preview', { ns: TRANSLATION_FILES.translation })}:</b>
                                </Grid.Column>
                              </Grid.Row>
                            </Grid>
                            {
                              customerData.icFrontDocument || customerData.icBackDocument ? (
                                <Grid>
                                  <Grid.Row>
                                    <Grid.Column mobile={16} tablet={16} computer={16}>
                                      <Grid centered>
                                        <Grid.Row style={{ paddingTop: 0, marginBottom: '3rem' }}>
                                          {
                                            customerData.icFrontDocument && customerData.icFrontDocument.name !== '' ? (
                                              <Grid.Column mobile={5} tablet={5} computer={5} style={{ marginTop: 'auto', marginBottom: 'auto' }}>
                                                {
                                                  customerData.icFrontDocument.name.toLowerCase().includes('.pdf') ? (
                                                    <div>
                                                      <Icon name="check circle" style={{ color: '#4183C4' }} />
                                                      <strong>
                                                        <a
                                                          href={AWSUrl(
                                                            this.props.appConfig,
                                                            customerData.icFrontDocument.key,
                                                          )}
                                                          target="_blank"
                                                        >
                                                          {customerData.icFrontDocument.name}
                                                        </a>
                                                      </strong>
                                                    </div>
                                                  ) : (
                                                    <LoadImage
                                                      centered
                                                      picture={customerData.icFrontDocument}
                                                      pictureSize={70}
                                                    />
                                                  )
                                                }
                                              </Grid.Column>
                                            ) : (
                                              <Grid.Column mobile={5} tablet={5} computer={5} style={{ marginTop: 'auto', marginBottom: 'auto' }}>
                                                <p>
                                                  <Icon name="exclamation circle" style={{ color: '#4183C4' }} />
                                                  {t('IC Front is not uploaded', { ns: TRANSLATION_FILES.translation })}
                                                </p>
                                              </Grid.Column>
                                            )
                                          }
                                          {
                                            customerData.icBackDocument && customerData.icBackDocument.name !== '' ? (
                                              <Grid.Column mobile={5} tablet={5} computer={5} style={{ marginTop: 'auto', marginBottom: 'auto' }}>
                                                {
                                                  customerData.icBackDocument.name.toLowerCase().includes('.pdf') ? (
                                                    <div>
                                                      <Icon name="check circle" style={{ color: '#4183C4' }} />
                                                      <strong>
                                                        <a
                                                          href={AWSUrl(
                                                            this.props.appConfig,
                                                            customerData.icBackDocument.key,
                                                          )}
                                                          target="_blank"
                                                        >
                                                          {customerData.icBackDocument.name}
                                                        </a>
                                                      </strong>
                                                    </div>
                                                  ) : (
                                                    <LoadImage
                                                      centered
                                                      picture={customerData.icBackDocument}
                                                      pictureSize={70}
                                                    />
                                                  )
                                                }
                                              </Grid.Column>
                                            ) : (
                                              <Grid.Column mobile={5} tablet={5} computer={5} style={{ marginTop: 'auto', marginBottom: 'auto' }}>
                                                <p>
                                                  <Icon name="exclamation circle" style={{ color: '#4183C4' }} />
                                                  {t('IC Back is not uploaded', { ns: TRANSLATION_FILES.translation })}
                                                </p>
                                              </Grid.Column>
                                            )
                                          }
                                        </Grid.Row>
                                      </Grid>
                                    </Grid.Column>
                                  </Grid.Row>
                                </Grid>
                              ) : null
                            }
                          </div>
                        ) : null
                      }
                    </Grid>
                  </Grid.Column>
                </Grid.Row>
              </Grid>
            :
              <Loader inline="centered">{t('Loading', { ns: TRANSLATION_FILES.translation })}</Loader>
          }
          </Modal.Content>
          <Modal.Actions>
            <Button onClick={this.handleClosePaymentModal} color="red">
              <Icon name="x" /> {t('Cancel', { ns: TRANSLATION_FILES.screens })}
            </Button>
            <Button onClick={this.handleSavePaymentModal} color="green">
              <Icon name="check" /> {t('Save', { ns: TRANSLATION_FILES.translation })}
            </Button>
          </Modal.Actions>
        </Modal>
        <Modal closeOnDimmerClick={false} open={modal.isOpen} size="small" className="booking-status-note">
          <Header icon={modal.headerIcon} content={modal.header} />
          <Modal.Content>
            <h4>{modal.message}</h4>
            <b>{t('Notes', { ns: TRANSLATION_FILES.screens })}* ({t('required', { ns: TRANSLATION_FILES.translation })})</b>
            <NoteEditor
              bookingNote={{ ...BookingNoteDefault }}
              hideCustomOptions
              onUpdate={this.handleNotesChange}
              auth={this.props.auth}
              settings={this.props.appConfig && this.props.appConfig.data && this.props.appConfig.data.settings}
            />
          </Modal.Content>
          <Modal.Actions>
            {
              !pendingCancelUnitsTab && modal.type === 'decline' &&
              <Checkbox
                label={t('Cancel all pending loan applications', { ns: TRANSLATION_FILES.translation })}
                checked={!pendingCancelUnitsTab && modal.isCancelPending}
                onChange={this.handleCheckboxChange}
              />
            }
            <Button onClick={this.handleCloseModal}>
              <Icon name="remove" /> {t('Cancel', { ns: TRANSLATION_FILES.screens })}
            </Button>
            <Button
              onClick={this.handleConfirm}
              color="green"
              icon="checkmark"
              content={modal.actionButtonText === 'Approve' ? t('Approve', { ns: TRANSLATION_FILES.screens }) : t('Decline', { ns: TRANSLATION_FILES.screens })}
            />
          </Modal.Actions>
        </Modal>
        <Grid verticalAlign="middle">
          {/* List Data */}
          <Grid.Row className="app--listdata app--mblr">
            <Grid.Column className="app--mblc">
              <br className="large-hide" />
              <Dimmer style={{ zIndex: 20 }} active={this.props.loading} inverted>
                <Loader inline="centered">{t('Loading', { ns: TRANSLATION_FILES.translation })}</Loader>
              </Dimmer>
              {
                this.state.data.length > 0 ?
                  <Grid columns={2} className="equal height">
                    <Grid.Row className="manage-booking-list-row">
                      <Grid.Column className="manage-booking-list-col" width={16}>
                        <Table celled className="manage-bookings">
                          { this.state.data.length > 0 ?
                            <Table.Header className="mobile-hide">
                              <Table.Row>
                                <Table.HeaderCell>{t('Booking', { ns: TRANSLATION_FILES.screens })}</Table.HeaderCell>
                                <Table.HeaderCell>{t('Purchaser', { ns: TRANSLATION_FILES.constants })}</Table.HeaderCell>
                                <Table.HeaderCell textAlign="right">{t(auth.company.countryCode === 'vn' ? 'List Price' : 'SPA', { ns: TRANSLATION_FILES.constants })} (<CurrencySymbol />)</Table.HeaderCell>
                                {showCancellationReason && <Table.HeaderCell>{t('Cancellation reason', { ns: TRANSLATION_FILES.translation })}</Table.HeaderCell>}
                                <Table.HeaderCell textAlign="center">{t('Assigned', { ns: TRANSLATION_FILES.translation })}</Table.HeaderCell>
                                <Table.HeaderCell textAlign="center">{t('Created', { ns: TRANSLATION_FILES.screens })}</Table.HeaderCell>
                                <Table.HeaderCell textAlign="center">{t('Manage', { ns: TRANSLATION_FILES.screens })} {pendingCancelUnitsTab ? t('Cancellation', { ns: TRANSLATION_FILES.screens }) : t('Booking', { ns: TRANSLATION_FILES.screens })}</Table.HeaderCell>
                              </Table.Row>
                            </Table.Header>
                            : null
                          }
                          <Table.Body>
                            {
                              this.state.data.map(unitdata => (
                                unitdata.bookings ?
                                this.generateRowStyle(unitdata.bookings).map((data, idx) => (
                                  <Table.Row
                                    key={idx}
                                    id={data.id}
                                    className={data.className}
                                    positive={data.approve}
                                    negative={data.decline}
                                  >
                                    {
                                    data.approve || data.decline ?
                                      <Table.Cell collapsing>
                                        {data.approve ? <span className="large-hide small-hide tablet-hide" style={{ float: 'right' }}><Icon name="check" /> {t('Approved', { ns: TRANSLATION_FILES.screens })}</span> : ''}
                                        {data.decline ? <span className="large-hide small-hide tablet-hide" style={{ float: 'right' }}><Icon name="cancel" /> {t('Cancelled', { ns: TRANSLATION_FILES.screens })}</span> : ''}
                                        <Link to={`/bookings/${data.id}/`}>
                                          {unitdata.reference}
                                        , <br className="large-hide" />
                                          {unitdata.project.shortName}
                                        , <br />
                                          <small>{data.code}</small>
                                        </Link>
                                      </Table.Cell>
                                    :
                                      <Table.Cell collapsing>
                                        <Button
                                          className="large-hide small-hide tablet-hide"
                                          floated="right"
                                          compact
                                          size="mini"
                                          negative
                                          onClick={(e) => {
                                            e.preventDefault();
                                            this.handleOpenModal(
                                              unitdata.id,
                                              data.id,
                                              data.newBookingNoteEncoded,
                                              'Decline',
                                              'remove',
                                              <span>{t(pendingCancelUnitsTab ? 'Decline Cancellation' : 'Decline Reservation', { ns: TRANSLATION_FILES.translation })}?
                                                <br /> {unitdata.reference}{', '}
                                                {unitdata.project.shortName}
                                              </span>,
                                              <span>
                                                {t('{{name}}\'s {{type}} ({{code}}) will {{status}}be cancelled.', {
                                                  name: data.bookingCustomer.name,
                                                  type: pendingCancelUnitsTab ? t('booking', { ns: TRANSLATION_FILES.translation }) : t('reservation', { ns: TRANSLATION_FILES.translation }),
                                                  code: data.code,
                                                  status: pendingCancelUnitsTab ? t('not ', { ns: TRANSLATION_FILES.translation }) : '',
                                                  ns: TRANSLATION_FILES.translation,
                                                })}
                                              </span>,
                                              'decline',
                                              data.updatedAt,
                                          );
                                          }}
                                        >
                                          {t('Decline', { ns: TRANSLATION_FILES.screens })}
                                        </Button>
                                        <Button
                                          className="large-hide small-hide tablet-hide"
                                          floated="right"
                                          compact
                                          size="mini"
                                          color="green"
                                          onClick={(e) => {
                                            e.preventDefault();
                                            this.handleOpenModal(
                                              unitdata.id,
                                              data.id,
                                              data.newBookingNoteEncoded,
                                              'Approve',
                                              'checkmark',
                                              <span>{t(pendingCancelUnitsTab ? 'Approve Cancellation' : 'Approve Booking', { ns: TRANSLATION_FILES.translation })}?
                                                <br /> {unitdata.reference}{', '}
                                                {unitdata.project.shortName}
                                              </span>,
                                              <span>
                                                {t('Approve {{name}}\'s {{type}} ({{code}})', {
                                                  name: data.bookingCustomer.name,
                                                  type: pendingCancelUnitsTab ? t('cancellation', { ns: TRANSLATION_FILES.translation }) : t('reservation', { ns: TRANSLATION_FILES.translation }),
                                                  code: data.code,
                                                  ns: TRANSLATION_FILES.translation,
                                                })}
                                                { (unitdata.projectUnitBookingSummary &&
                                                  unitdata.projectUnitBookingSummary.reservedCount
                                                  > 1)
                                                  && <br />
                                                }
                                                { (!pendingCancelUnitsTab && unitdata.projectUnitBookingSummary &&
                                                  unitdata.projectUnitBookingSummary.reservedCount
                                                  > 1)
                                                  && t('All other reservations for this unit will be set to unsuccessful reservation.', { ns: TRANSLATION_FILES.translation })
                                                }
                                              </span>,
                                              'approve',
                                              data.updatedAt,
                                            );
                                          }}
                                        >
                                          {t('Approve', { ns: TRANSLATION_FILES.screens })}
                                        </Button>
                                        <Button
                                          className="large-hide small-hide tablet-hide"
                                          floated="right"
                                          compact
                                          size="mini"
                                          icon
                                          onClick={
                                            () => this.handleOpenPaymentModal(data.id, unitdata.id)
                                          }
                                        >
                                          <Icon name="pencil" />
                                        </Button>
                                        <Link to={`/bookings/${data.id}/`}>
                                          {unitdata.reference}
                                        , <br className="large-hide" />
                                          {unitdata.project.shortName}
                                        , <br />
                                          <small>{data.code}</small>
                                        </Link>
                                      </Table.Cell>
                                    }
                                    <Table.Cell className="mobile-hide">
                                      <span className="mobile-hide">
                                        <Link to={`/bookings/${data.id}/`}>{data.bookingCustomer.name}</Link>
                                      </span>
                                    </Table.Cell>
                                    <Table.Cell collapsing className="mobile-hide" textAlign="right">
                                      <div className="mobile-hide">
                                        <small>
                                          {t(data.paymentStatus.name, { ns: TRANSLATION_FILES.constants })}
                                        </small>
                                        {
                                          data.paymentPictures && data.paymentPictures.length > 0 ?
                                            <span>&nbsp;&nbsp;</span>
                                            : ''
                                        }
                                        {
                                          data.paymentPictures && data.paymentPictures.length > 0 ?
                                            <Button
                                              onClick={(e) => {
                                                e.preventDefault();
                                                this.handleOpenAttachment(data);
                                              }}
                                              icon
                                              compact
                                              size="mini"
                                              color="vk"
                                              title={t('View Attachments', { ns: TRANSLATION_FILES.translation })}
                                            >
                                              <Icon name="attach" /> {data.paymentPictures.length}
                                            </Button>
                                          : ''
                                        }
                                        <br />
                                        <LoanAmount
                                          format="0,000,000.00"
                                          amount={spaFullNumber(data) || data.spaValue}
                                          prefix={<CurrencySymbol />}
                                        />
                                      </div>
                                    </Table.Cell>
                                    {
                                      showCancellationReason && (
                                        <Table.Cell className="mobile-hide">
                                          {cancellationCategoryLabel(data.srCancellationType)
                                            ? `${t(cancellationCategoryLabel(data.srCancellationType), { ns: TRANSLATION_FILES.translation })}`
                                            : '-'}
                                        </Table.Cell>
                                      )
                                    }
                                    <Table.Cell collapsing textAlign="right">
                                      <span style={{ float: 'left' }} className="large-hide small-hide tablet-hide">
                                        <Link to={`/bookings/${data.id}/`}>{data.bookingCustomer.name}</Link>
                                      </span>
                                      <small className="large-hide small-hide tablet-hide">
                                        <i>{data.assignedMaPreferredName ? `Assigned: ${data.assignedMaPreferredName}` : <span>&nbsp;</span>}</i>
                                      </small>
                                      <span className="mobile-hide" style={{ float: 'left' }}>
                                        <small>
                                          {
                                            data.assignedMaPreferredName ?
                                            data.assignedMaPreferredName :
                                            <Button
                                              className="mobile-hide"
                                              size="mini"
                                              disabled={data.approve || data.decline}
                                              onClick={
                                                () =>
                                                this.handleOpenPaymentModal(data.id, unitdata.id)
                                              }
                                            >
                                              <Icon name="add user" /> {t('Assign', { ns: TRANSLATION_FILES.translation })}
                                            </Button>
                                          }
                                        </small>
                                      </span>
                                    </Table.Cell>
                                    <Table.Cell collapsing textAlign="right">
                                      <small>
                                        <span style={{ float: 'left' }} className="large-hide small-hide tablet-hide">
                                          <b>SPA: </b>
                                          <LoanAmount
                                            format="0,000,000.00"
                                            amount={spaFullNumber(data) || data.spaValue}
                                            prefix={<CurrencySymbol />}
                                          />&nbsp;
                                          {
                                            data.paymentPictures && data.paymentPictures.length > 0 ?
                                              <button
                                                className="a-button-blue"
                                                onClick={(e) => {
                                                  e.preventDefault();
                                                  this.handleOpenAttachment(data);
                                                }}
                                                title={t('View Attachments', { ns: TRANSLATION_FILES.translation })}
                                              >
                                                ({t(data.paymentStatus.name, { ns: TRANSLATION_FILES.constants })} <b><Icon name="attach" />{data.paymentPictures.length})</b>
                                              </button>
                                              : `(${t(data.paymentStatus.name, { ns: TRANSLATION_FILES.constants })})`
                                          }
                                        </span>
                                      </small>
                                      <i>
                                        <small>
                                          <span>{t('by', { ns: TRANSLATION_FILES.translation })} </span>
                                          { this.hasStaffAccess() ?
                                            <Link to={`/users/${data.maUserAffiliateID}/`} >
                                              {data.maCreatedByPreferredName}
                                            </Link>
                                            : data.maCreatedByPreferredName
                                          }

                                          <span className="large-hide small-hide tablet-hide">,</span><br className="mobile-hide" />
                                          <Timestamp
                                            timestamp={data.createdAt}
                                            precise
                                          />
                                        </small>
                                      </i>
                                    </Table.Cell>
                                    {
                                    data.approve || data.decline ?
                                      <Table.Cell
                                        collapsing
                                        className="mobile-hide"
                                        textAlign="center"
                                      >
                                        {data.approve ? <span><Icon name="check" /> {t('Approved', { ns: TRANSLATION_FILES.constants })}</span> : ''}
                                        {data.decline ? <span><Icon name="cancel" /> {t('Cancelled', { ns: TRANSLATION_FILES.constants })}</span> : ''}
                                      </Table.Cell>
                                    :
                                      <Table.Cell collapsing className="mobile-hide">
                                        <Button
                                          className="mobile-hide"
                                          size="mini"
                                          icon
                                          onClick={
                                            () => this.handleOpenPaymentModal(data.id, unitdata.id)
                                          }
                                        >
                                          <Icon name="pencil" />
                                        </Button>
                                        <Button
                                          className="mobile-hide"
                                          size="mini"
                                          color="green"
                                          onClick={(e) => {
                                            e.preventDefault();
                                            this.handleOpenModal(
                                              unitdata.id,
                                              data.id,
                                              data.newBookingNoteEncoded,
                                              'Approve',
                                              'checkmark',
                                              <span>{t(pendingCancelUnitsTab ? 'Approve Cancellation' : 'Approve Booking', { ns: TRANSLATION_FILES.translation })}?
                                                <br /> {unitdata.reference}{', '}
                                                {unitdata.project.shortName}
                                              </span>,
                                              <span>
                                                {t('Approve {{name}}\'s {{type}} ({{code}})', {
                                                  name: data.bookingCustomer.name,
                                                  type: pendingCancelUnitsTab ? t('cancellation', { ns: TRANSLATION_FILES.translation }) : t('reservation', { ns: TRANSLATION_FILES.translation }),
                                                  code: data.code,
                                                  ns: TRANSLATION_FILES.translation,
                                                })}
                                                { (unitdata.projectUnitBookingSummary &&
                                                  unitdata.projectUnitBookingSummary.reservedCount
                                                  > 1)
                                                  && <br />
                                                }
                                                { (!pendingCancelUnitsTab && unitdata.projectUnitBookingSummary &&
                                                  unitdata.projectUnitBookingSummary.reservedCount
                                                  > 1)
                                                  && t('All other reservations for this unit will be set to unsuccessful reservation.', { ns: TRANSLATION_FILES.translation })
                                                }
                                              </span>,
                                              'approve',
                                              data.updatedAt,
                                            );
                                          }}
                                        >
                                          {t('Approve', { ns: TRANSLATION_FILES.screens })}
                                        </Button>
                                        <Button
                                          className="mobile-hide"
                                          size="mini"
                                          negative
                                          onClick={(e) => {
                                            e.preventDefault();
                                            this.handleOpenModal(
                                              unitdata.id,
                                              data.id,
                                              data.newBookingNoteEncoded,
                                              'Decline',
                                              'remove',
                                              <span>{t(pendingCancelUnitsTab ? 'Decline Cancellation' : 'Decline Reservation', { ns: TRANSLATION_FILES.translation })}?
                                                <br /> {unitdata.reference}{', '}
                                                {unitdata.project.shortName}
                                              </span>,
                                              <span>
                                                {t('{{name}}\'s {{type}} ({{code}}) will {{status}}be cancelled.', {
                                                  name: data.bookingCustomer.name,
                                                  type: pendingCancelUnitsTab ? t('booking', { ns: TRANSLATION_FILES.translation }) : t('reservation', { ns: TRANSLATION_FILES.translation }),
                                                  code: data.code,
                                                  status: pendingCancelUnitsTab ? t('not ', { ns: TRANSLATION_FILES.translation }) : '',
                                                  ns: TRANSLATION_FILES.translation,
                                                })}
                                              </span>,
                                              'decline',
                                              data.updatedAt,
                                          );
                                          }}
                                        >
                                          {t('Decline', { ns: TRANSLATION_FILES.screens })}
                                        </Button>
                                      </Table.Cell>
                                    }
                                  </Table.Row>
                                ))
                                :
                                null
                              ))
                            }
                          </Table.Body>
                        </Table>
                      </Grid.Column>
                    </Grid.Row>
                  </Grid>
                  : (
                    <Grid>
                      <Grid.Row>
                        <Grid.Column>
                          <Item style={{}}>
                            <Item.Content>
                              {
                              !this.props.loading ?
                                <Segment textAlign="center">
                                  <p>{t('No pending bookings found.', { ns: TRANSLATION_FILES.translation })}</p>
                                </Segment>
                              : ''
                              }
                            </Item.Content>
                          </Item>
                        </Grid.Column>
                      </Grid.Row>
                    </Grid>
                  )
                }
            </Grid.Column>
          </Grid.Row>
        </Grid>
      </Container>
    );
  }
}

export default withTranslation(namespaces)(withRouter(connect(PendingUnits.mapStateToProps)(PendingUnits)));



// WEBPACK FOOTER //
// ./src/containers/Bookings/Manage/PendingUnits.jsx